import Vue from 'vue';
import Vuex from 'vuex';
import OrgInfo from './class/OrgInfo';
import Message from './class/Message';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null as unknown,
    cognito: null as unknown,
    organization: null as OrgInfo[] | null,
    group: {} as any | null,
    message: {} as any | null,
    showOrg: null as unknown,
    title: '名前はまだない',
  },
  mutations: {
    updateTitle(state, str) {
      state.title = str;
      (document.querySelector('title') as any).innerHTML = `らびっとめーる ${str}`;
    },
    signIn(state, user) {
      state.user = user;
      localStorage.setItem('rabbit-user', JSON.stringify(state.user));
    },
    setCognito(state, user) {
      state.cognito = user;
    },
    signOut(state) {
      state.user = null;
      state.cognito = null;
      state.organization = null;
      state.group = {};
      state.message = {};
      state.showOrg = null;
      localStorage.removeItem('rabbit-user');
      localStorage.removeItem('rabbit-organization');
      localStorage.removeItem('rabbit-group');
      localStorage.removeItem('rabbit-message');
      localStorage.removeItem('rabbit-showOrg');
      localStorage.removeItem('rabbit-path');
    },
    setOrganization(state, organization: OrgInfo[]) {
      if (state.organization) {
        state.organization!.forEach((old) => {
          let flg = true;
          (organization ? organization : []).forEach((newO) => {
            if (old.ID === newO.ID) {
              flg = false;
            }
          });
          if (flg) {
            if (state.group[old.ID]) {
              state.group[old.ID].forEach((g: OrgInfo) => {
                if (state.message[g.ID]) {
                  delete state.message[g.ID];
                  localStorage.setItem('rabbit-message', JSON.stringify(state.message));
                }
              });
              delete state.group[old.ID];
              localStorage.setItem('rabbit-group', JSON.stringify(state.group));
            }
            if (state.message[old.ID]) {
              delete state.message[old.ID];
              localStorage.setItem('rabbit-message', JSON.stringify(state.message));
            }
          }
        });
      }
      state.organization = organization;
      localStorage.setItem('rabbit-organization', JSON.stringify(state.organization));
    },
    organizationAdd(state, organization: OrgInfo) {
      if (!state.organization) {
        state.organization = new Array<OrgInfo>();
      }
      state.organization.push(organization);
      localStorage.setItem('rabbit-organization', JSON.stringify(state.organization));
    },
    setGroup(state, obj: { id: string, groups: OrgInfo[] }) {
      if (state.group[obj.id]) {
        state.group[obj.id].forEach((g: OrgInfo) => {
          let flg = true;
          (obj.groups ? obj.groups : []).forEach((newG) => {
            if (g.ID === newG.ID) {
              flg = false;
            }
          });
          if (flg) {
            if (state.message[g.ID]) {
              delete state.message[g.ID];
              localStorage.setItem('rabbit-message', JSON.stringify(state.message));
            }
          }
        });
      }
      const tmp: any = {};
      Object.assign(tmp, state.group);
      tmp[obj.id] = obj.groups;
      state.group = tmp;
      localStorage.setItem('rabbit-group', JSON.stringify(state.group));
    },
    updateGroup(state, g: OrgInfo) {
      if (g.Parent && g.Parent !== null) {
        state.group[g.Parent].forEach((tmp: OrgInfo) => {
          if (g.ID === tmp.ID) {
            tmp = g;
          }
        });
        localStorage.setItem('rabbit-group', JSON.stringify(state.group));
      } else if (state.organization != null) {
        state.organization.forEach((tmp: OrgInfo) => {
          if (g.ID === tmp.ID) {
            tmp = g;
          }
        });
        localStorage.setItem('rabbit-organization', JSON.stringify(state.organization));
      }
    },
    setMessage(state, obj: { id: string, messages: Message[] }) {
      state.message[obj.id] = obj.messages;
      const tmp: any = {};
      Object.assign(tmp, state.message);
      state.message = tmp;
      localStorage.setItem('rabbit-message', JSON.stringify(state.message));
    },
    addMessage(state, obj: { id: string, messages: Message[] }) {
      if (!state.message[obj.id]) {
        state.message[obj.id] = new Array<Message>();
      }
      for (const m of obj.messages) {
        state.message[obj.id].push(m);
      }
      const tmp: any = {};
      Object.assign(tmp, state.message);
      state.message = tmp;
      localStorage.setItem('rabbit-message', JSON.stringify(state.message));
    },
    updateMessage(state, m: Message) {
      if (!state.message[m.OrganizationID]) {
        return;
      }
      for (let i = 0; i < state.message[m.OrganizationID].length; i++) {
        if (state.message[m.OrganizationID][i].ID === m.ID) {
          state.message[m.OrganizationID][i] = m;
          break;
        }
      }
    },
    showOrg(state, id) {
      state.showOrg = id;
      localStorage.setItem('rabbit-showOrg', JSON.stringify(state.showOrg));
    },
    sortOrg(state: any, obj: { prop: string, asc: boolean }) {
      state.organization.sort((o1: any, o2: any) => {
        const prop = obj.prop;
        return (obj.asc ? o1[prop] < o2[prop] : o2[prop] < o1[prop]) ? -1 : 1;
      });
    },
    sortGroup(state: any, obj: { id: string, prop: string, asc: boolean }) {
      if (!state.group[obj.id]) {
        return;
      }
      state.group[obj.id]!.sort((o1: any, o2: any) => {
        const prop = obj.prop;
        return (obj.asc ? o1[prop] < o2[prop] : o2[prop] < o1[prop]) ? -1 : 1;
      });
    },
    sortMessage(state: any, obj: { id: string, prop: string, asc: boolean }) {
      state.message[obj.id].sort((m1: any, m2: any) => {
        return (obj.asc ? m1[obj.prop] < m2[obj.prop] : m2[obj.prop] < m1[obj.prop]) ? -1 : 1;
      });
    },
  },
});

